// App A (Sender)
const SECRET_KEY = 'onlyusedtesla';

export async function generateIdentityToken(): Promise<string> {
  const timestamp = Date.now().toString();
  const randomBytes = new Uint8Array(8);
  crypto.getRandomValues(randomBytes);
  const random = Array.from(randomBytes).map(b => b.toString(16).padStart(2, '0')).join('');
  const data = `${timestamp}.${random}`;
  const encoder = new TextEncoder();
  const key = await crypto.subtle.importKey(
    'raw',
    encoder.encode(SECRET_KEY),
    { name: 'HMAC', hash: 'SHA-256' },
    false,
    ['sign']
  );
  const signatureBuffer = await crypto.subtle.sign(
    'HMAC',
    key,
    encoder.encode(data)
  );
  const signature = Array.from(new Uint8Array(signatureBuffer)).map(b => b.toString(16).padStart(2, '0')).join('');
  return `${data}.${signature}`;
}
